module.exports = __webpack_public_path__ + "static/media/55_000068.282669ee.jpg";